import { DetailProduct } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getProductDetail } from '../queries/products';
import { useAuthStore } from '../stores';

export function getProductDetailOptions(
  access_token: string,
  productId: string,
  warehouse: string
) {
  return queryOptions<DetailProduct>({
    queryKey: ['ProductDetail', warehouse, productId],
    queryFn: () => getProductDetail(access_token, productId, warehouse),
    staleTime: 1000 * 60 * 4,
  });
}

export const useGetProductDetail = (
  productId: string | undefined,
  warehouse: string | undefined
) => {
  const accessToken = useAuthStore((state) => state.access_token);
  return useQuery({
    ...getProductDetailOptions(accessToken, productId || '', warehouse || ''),
    enabled: !!productId && !!warehouse,
  });
};
